
/**
 * An object used to get page information from the server
 */
export class Pagination implements IPagination {

  /**
   * The number of entities in the page
   */
  public pageSize = 0;

  /**
   * The total number of entities
   */
  public totalCount = 0;

  /**
   * The total number of pages available
   */
  public totalPages = 0;

  /**
   * The current page number
   */
  public currentPage = 0;

  /**
   * If there is a previous page
   */
  public hasPrevious = false;

  /**
   * If there is another page
   */
  public hasNext = false;

  public constructor(data: Partial<IPagination>) {
    Object.assign(this, data);
  }
}

export interface IPagination {
  pageSize: number;
  totalCount: number;
  totalPages: number;
  currentPage: number;
  hasPrevious: boolean;
  hasNext: boolean;
}
